import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { LoaderService } from "../services/loader.service";
import { FeedbackService } from "../services/feedback.service";
import { LogService } from "../services/log.service";
@Component({
  selector: "app-change-passcode",
  templateUrl: "./change-passcode.component.html",
  styleUrls: ["./change-passcode.component.css"]
})
export class ChangePasscodeComponent implements OnInit {
  public changePasscodeForm: FormGroup;
  public old: string;
  public pnew: string;
  public cnew: string;
  public response;
  public respDisp;
  constructor(
    private fb: FormBuilder,
    private _userService: UserService,
    private _Router: Router,
    private _loaderService: LoaderService,
    private _feedbackService: FeedbackService,
    private log:  LogService
  ) {
    this.changePasscodeForm = this.fb.group({
      old: [""],
      pnew: ["", Validators.compose([Validators.required, Validators.minLength(6)])],
      cnew: ["", Validators.compose([Validators.required, Validators.minLength(6)])]
    });
  }

  ngOnInit() {
    this.log
      .addLog({
        action: "Access",
        component: "Change Passcode",
        details: `Access Change Passcode`,
    }).subscribe(data => { });
  }
  changePasscode(details) {
    this._loaderService.emitChange(true)
    this._userService.changePasscode(details.value).subscribe(data => {
      if (data.success) {
        let obj = {};
        this.log.addLog({
          action: `Edit`,
          component: "Change Passcode",
          details: `Changed Password`
        })
        .subscribe(data => { });
        this._feedbackService.emitChange("Password changed succesully", "primary-color");
        this._Router.navigate(["login"]);
      } else {
        this._feedbackService.emitChange("Failed. Please try again", "failed-color");
      }
      this._loaderService.emitChange(false);
    });
  }

  addLog () {
    let obj = {};
    this.log.addLog({
      action: `Edit`,
      component: "Change Passcode",
      details: `Changed Password`
    })
    .subscribe(data => { });
  }
}
